<router-outlet></router-outlet>

<footer class="tw-text-center tw-my-12">
  <environment-selector></environment-selector>

  <div bitTypography="body2">Box</div>
  <div bitTypography="body2">{{ version }}</div>
  <br />
  <div bitTypography="helper" id="vw-disclaimer">
    <br />
    Box is not associated with the Box&reg; project nor Box Inc.
  </div>
</footer>
